/*eslint-disable react/no-set-state*/
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import ProfileBasicInfo from './ProfileBasicInfo';
import ProfileUpdateForm from './ProfileUpdateForm';
import ProfileHeading from './ProfileHeading';
import ProfileApiToken from './ProfileApiToken';
import ProfileApiTokenModal from './ProfileApiTokenModal';
import { ITAAlert } from '../../common/ITAAlert';
import { searchForFormById } from '../../../selectors/searchForForm';
import * as userUpdateActions from '../../../actions/userActions';
import * as errorMessages from '../../../constants/errorMessages';
import * as FormName from '../../../constants/formNameConstants';
import * as paths from '../../../constants/pathConstants';
import '../../../styles/accountCreation/accountCreation.css';
//import ProfilePasswordPage from './ProfilePasswordPage';

export class ProfileManagementPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    let currentActivePage = "1";
    this.state = {
      newInfo: {},
      currentActivePage,
      activeFields: [],
      errors: {},
      message: "",
      expiredTokenMsg: "",
      formIsValid: true,
      submittingUsers: false,
      modalShown: false
    };

    this.enteringUser = this.enteringUser.bind(this);
    this.updateUser = this.updateUser.bind(this);
    this.refreshToken = this.refreshToken.bind(this);
    this.changeTab = this.changeTab.bind(this);
    this.copyToken = this.copyToken.bind(this);
    this.setActiveFields = this.setActiveFields.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.resetFields = this.resetFields.bind(this);
  }
  componentWillReceiveProps(newProps) {
    if (newProps.path == paths.pathToAccountPage.slice(1) && this.state.currentActivePage !== "1") {
      this.setState({ currentActivePage: "1" });
    } else if (newProps.path == paths.pathToAccountEditPage.slice(1) && this.state.currentActivePage !== "2") {
      this.setState({ currentActivePage: "2" });
    } else if (newProps.path == paths.pathToApiTokenPage.slice(1) && this.state.currentActivePage !== "3") {
      this.setState({ currentActivePage: "3" });
    }
    this.setState({ message: "" });
  }

  changeTab(event) {
    event.preventDefault();
    browserHistory.push(event.target.name);
  }

  copyToken() {
    let tokenField = document.createElement('textarea');
    tokenField.innerText = this.props.user.token;
    document.body.appendChild(tokenField);
    tokenField.select();
    document.execCommand('copy');
    tokenField.remove();
  }

  updateUser(event) {
    event.preventDefault();
    const newInfo = this.state.newInfo;
    this.props.actions.updateUser(newInfo)
      .then((response) => {
        if (response.status !== "success") {
          throw (new Error(errorMessages.ERROR_USER_UPDATE));
        } else {
          browserHistory.push(paths.accountPageBase + paths.pathToAccountPage);
          this.setState({ newInfo: {} });
          this.setState({ message: "Your account profile has been updated." });
        }
      })
      .catch(error => {
        throw (error);
      });
    window.scrollTo(0, 0);
  }

  refreshToken(event) {
    event.preventDefault();
    this.toggleModal();
    this.props.actions.refreshToken()
      .then((response) => {
        if (response == "failure") {
          this.setState({ expiredTokenMsg: errorMessages.ERROR_API_GENERATE });
        } else if (response == "success") {
          this.setState({ message: "A new API token was successfully generated for your account.", expiredTokenMsg: "" });
        }
      })
      .catch(error => {
        throw (error);
      });
  }

  enteringUser(event) {
    event.preventDefault();
    let field = event.target.name;
    if (field === "phoneNumber") {
      field = "telephone";
    }
    let user = this.props.user;
    let newInfo = this.state.newInfo;
    newInfo[field] = event.target.value;
    this.setActiveFields(field);
    this.setState({ newInfo: newInfo });
    this.setState({
      formIsValid: this.formIsValid(user, newInfo, this.props.requiredFields,
        this.state.activeFields).formIsValid
    });
    this.setState({
      errors: this.formIsValid(user, newInfo, this.props.requiredFields,
        this.state.activeFields).errors
    });
  }

  resetFields(event) {
    event.preventDefault();
    window.location.href = paths.accountPageBase + paths.pathToAccountPage;
  }

  onBlur(event) {
    event.preventDefault();
    let user = this.props.user;
    let newInfo = this.state.newInfo;
    const field = event.target.name;
    this.setActiveFields(field);
    this.setState({
      formIsValid: this.formIsValid(user, newInfo, this.props.requiredFields,
        this.state.activeFields).formIsValid
    });
    this.setState({
      errors: this.formIsValid(user, newInfo, this.props.requiredFields,
        this.state.activeFields).errors
    });
  }
  setActiveFields(field) {
    let activeFields = this.state.activeFields;
    if (activeFields.indexOf(field) == -1) {
      activeFields.push(field);
      this.setState({ activeFields: activeFields });
    }
  }
  formIsValid(user, newInfo, requiredFields, activeFields) {
    let formIsValid = true;
    let errors = {};
    requiredFields.map(questionPart => {
      let fieldName = questionPart.questionPartName;
      let label = questionPart.questionPartLabel;
      if (activeFields.indexOf(fieldName) !== -1 && newInfo[fieldName] == "") {
        errors[fieldName] = label + errorMessages.ERROR_NEEDS_VALUE;
      }
    });
    if (newInfo.telephone && checkPhoneNumberForErrors(newInfo.telephone)) {
      errors.phoneNumber = errorMessages.ERROR_PHONE_NUMBER_NOT_CORRECT;
    }
    //email validation
    let re = new RegExp('[A-Z0-9._%+-]+@[A-Z0-9.-]+[\.][A-Z]{2,}', 'i');
    if (newInfo.email && newInfo.email.search(re) == -1) {
      formIsValid = false;
      errors.email = errorMessages.ERROR_INVALID_EMAIL;
    }
    if (Object.keys(errors).length !== 0 && errors.constructor === Object) {
      formIsValid = false;
    }
    return { formIsValid, errors };

  }
  toggleModal() {
    this.setState({
      modalShown: !this.state.modalShown
    });
  }
  render() {
    return (
      <div id="account-page">
        {this.state.message && <div className="row">
          <div className="col-xs-12 col-sm-9">
            <ITAAlert
              hidden={false}
              style="success"
              message={<div className="first-line">{this.state.message} </div>} />
          </div>
        </div>}
        {this.state.expiredTokenMsg && <div className="row">
          <div className="col-xs-12 col-sm-9">
            <ITAAlert
              hidden={false}
              style="danger"
              message={<div className="first-line">Your token has expired. Please submit an {<a href="/injuryreporting/ita/help-request-form" title="submit a request">ITA Help Desk Request</a>} to have your token reset.</div>} />
          </div>
        </div>}
        {this.props.user && <span>
          <ProfileHeading
            user={this.props.user}
            onClick={this.changeTab}
            activeTab={this.state.currentActivePage} />
          <div
            className="profile-tab row basic-info"
            hidden={this.state.currentActivePage !== "1"}>
            <ProfileBasicInfo user={this.props.user} startUpdate={this.changeTab} />
          </div>
          <div
            className="profile-tab row edit-info"
            hidden={this.state.currentActivePage !== "2"}>
            <ProfileUpdateForm
              user={this.props.user}
              resetFields={this.resetFields}
              form={this.props.userCreationForm}
              onChange={this.enteringUser}
              onSubmit={this.updateUser}
              onBlur={this.onBlur}
              submitStatus={this.state.formIsValid}
              errors={this.state.errors} />
          </div>
          <div
            className="api-token-tab row"
            hidden={this.state.currentActivePage !== "3"}>
            <ProfileApiToken user={this.props.user} onShow={this.toggleModal} copy={this.copyToken} />
            <ProfileApiTokenModal
              modalShown={this.state.modalShown}
              onHide={this.toggleModal}
              refreshAction={this.refreshToken} />
          </div>
        </span>}
      </div>
    );
  }
}

ProfileManagementPage.contextTypes = {
  router: PropTypes.object
};

ProfileManagementPage.propTypes = {
  actions: PropTypes.object.isRequired,
  user: PropTypes.object,
  userCreationForm: PropTypes.object.isRequired,
  path: PropTypes.string,
  requiredFields: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
  let user = state.user[0];
  let userCreationForm = {};
  let requiredFields = [];
  if (user) {
    user = mapUserObjectToUserFormObject(user);
  }
  if (state.forms.length > 0) {
    userCreationForm = searchForFormById(state.forms, FormName.userCreationFormId);
  }
  if (userCreationForm && userCreationForm.formQuestions) {
    requiredFields = []
      .concat
      .apply([], userCreationForm.formQuestions.map(question => {
        let required = question
          .questionParts
          .map(questionPart => {
            if (questionPart.questionPartRequired == "1" && questionPart.questionPartName != "username" && questionPart.questionPartName != "emailValidation") {
              return questionPart;
            }
          })
          .filter(questionPart => {
            return questionPart;
          });
        return required;
      }));
  }
  let path = ownProps.params.extension2
    ? ownProps.params.extension + '/' + ownProps.params.extension2
    : ownProps.params.extension;
  return { user, userCreationForm, path, requiredFields };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(userUpdateActions, dispatch)
  };
}

function mapUserObjectToUserFormObject(user) {
  return {
    phoneNumber: user.telephone,
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    companyName: user.companyName,
    jobTitle: user.jobTitle,
    token: user.token,
    userId: user.userId,
    username: user.username,
    password: user.password
  };
}

function checkPhoneNumberForErrors(phoneNumber) {
  if (phoneNumber.match(/[A-Za-z]/g) || phoneNumber.match(/\d/g).length !== 10) {
    return true;
  }

  return false;
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileManagementPage);



/** WEBPACK FOOTER **
 ** ./src/components/account/manageAccount/ProfileManagementPage.js
 **/